/**
 * User Domain Entity
 *
 * Represents a user in the system with business rules and validations.
 * This entity is part of the Domain layer and contains no external dependencies.
 */

export interface User {
  id: string;
  email: string;
  name: string;
}

export class UserEntity implements User {
  constructor(
    public id: string,
    public email: string,
    public name: string
  ) {
    this.validateEmail(email);
    this.validateName(name);
  }
  

  /**
   * Validates email format using regex
   */
  private validateEmail(email: string): void {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      throw new Error('Invalid email format');
    }
  }

  /**
   * Validates that name is not empty
   */
  private validateName(name: string): void {
    if (!name || name.trim().length === 0) {
      throw new Error('Name cannot be empty');
    }
  }

  /**
   * Returns the display name for the user
   */
  public getDisplayName(): string {
    return this.name || this.email;
  }

  /**
   * Returns initials from the user's name
   */
  public getInitials(): string {
    const nameParts = this.name.trim().split(' ');
    if (nameParts.length >= 2) {
      return `${nameParts[0]?.[0] ?? ''}${nameParts[1]?.[0] ?? ''}`.toUpperCase();
    }
    return (nameParts[0]?.[0] ?? '').toUpperCase();
  }
}
